import { render } from "./TipoReporte.vue?vue&type=template&id=2ee06113"
import script from "./TipoReporte.vue?vue&type=script&lang=js"
export * from "./TipoReporte.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__